import {
    apiRequest,
    seminarUpdate
} from "../../../../../../services/adapters/kepegawaian/seminarService"

class UpdateRepository {

    fetchUpdate = async (query) => {
        return await apiRequest("post", seminarUpdate, {
            body: query
        }, true)
    }

}

export default UpdateRepository